import enUS from './enUS'

const enGB = {
  ...enUS
}

export default enGB
